import React from "react";

export function CPUPP_PBINGABConfig() {
  return (
    <div>
      <p>No permissions available for this product. All users in this application are set to Super Admin.</p>
    </div>
  );
}
